import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.833 11.333H6.167c-1.748.002-3.164 1.48-3.167 3.305V18h14v-3.362c-.003-1.824-1.419-3.302-3.167-3.305M10 2c2.117 0 3.833 1.79 3.833 4S12.117 10 10 10 6.167 8.21 6.167 6 7.883 2 10 2"
    }, null, -1)
  ])))
}
export default { render: render }